// pages/pricing.jsx
export const runtime = 'experimental-edge';
import React from 'react';
import BaseLayout from '../layouts/BaseLayout.jsx';
import PricingTable from '../components/PricingTable';
import PricingFAQ from '../components/PricingFAQ';
import { getServerSideAuth } from '../utils/serverSideAuth';

export async function getServerSideProps(context) {
  const authState = await getServerSideAuth(context);
  
  let subscriptionData = null;
  
  if (authState.isAuthenticated && authState.user) {
    try {
      const backendUrl = process.env.NEXT_PUBLIC_BACKEND_URL;
      
      const response = await fetch(`${backendUrl}/subscription/status`, {
        headers: {
          'Authorization': `Bearer ${context.req.cookies.jwt_access_token || ''}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (response.ok) {
        subscriptionData = await response.json();
      }
    } catch (error) {
      console.error('Error fetching subscription data:', error);
    }
  }

  return {
    props: {
      serverAuth: authState,
      initialSubscription: subscriptionData
    }
  };
}

const PricingPage = ({ serverAuth, initialSubscription }) => {
  return (
    <BaseLayout
      title="Pricing"
      description="Our pricing plans and options"
      showHeader={true}
    >
      <div className="page-container-with-top-margin w-full">
        <div className="w-full">
          {/* Увеличенный отступ сверху (mt-10) */}
          <h1 className="text-3xl md:text-4xl font-bold text-center mt-10 mb-4 md:mb-6">Subscription Plans and Pricing</h1>
          <p className="text-lg md:text-xl text-center text-gray-700 mb-6 md:mb-8 max-w-[800px] mx-auto">
            Choose the plan that best fits your needs. Get the best value with annual billing.
          </p>
          
          <PricingTable 
            initialSubscriptionData={initialSubscription}
            initialAuth={serverAuth}
          />
          
          <PricingFAQ />
        </div>
      </div>
    </BaseLayout>
  );
};

export default PricingPage;